import { Switch, Route, Redirect, useLocation } from "react-router-dom";
import { useAuth } from "../context/authcontext";

//views - main
import Main from '../viewsxz/main';
import Creators from "../viewsxz/creators";
import Collections from "../viewsxz/collections";
import Resources from "../viewsxz/resources";

// views - user
import HomeUser from "../viewsxx/home-indx";

// views - vault
import Store from "../viewsvs/store";

// views - vault
import Vault from "../viewsxv/vault";

//views - collections
import CollectionsCreate from "../viewsvc/collections-create";
import CollectionsList from "../viewsvc/collections-list";
import CollectionsView from "../viewsvc/collections-view";

import MediaCreate from "../viewsvm/media-create";
import MediaView from "../viewsvm/media-view";
import MediaEdit from "../viewsvm/media-edit";

//views - tokens
import TokensCreate from "../viewsvt/tokens-create";
import TokensMint from "../viewsvt/tokens-mint";
import TokensView from "../viewsvt/tokens-view";

// views - network
import Network from "../viewsxc/network";
import NetworkInvite from "../viewsxc/network-invite";


// views - transfers
import TransfersList from "../viewsxt/transfers-list";
import TransfersDebit from "../viewsxt/transfers-debit";

import AccountCredit from "../viewsxt/account-credit";

// views - accounts
import AccountsList from "../viewsxt/accounts-list";

// views - user
import Settings from "../viewsxs/settings";

// views - auth - onbd
import AuthMailFirebase from "../viewsxa/auth-mail-firebase";
import AuthMailCheckFirebase from "../viewsxa/auth-mail-check";
import AuthNext from "../viewsxa/auth-next";
import AuthSessionX from "../viewsxa/auth-session-x";

import OnboardUser from "../viewsxb/onboard-user";

import AuthService from "../viewsxa/auth-service";

// import AuthWeb3 from "../viewsxa/auth-web3";
// import OnboardBusiness from "../viewsxb/onboard-daos";
// import OnboardWeb3 from "../viewsxb/onboard-web3";

const routes = [

  // main
  { path:'/', component: Main, auth:false },
  { path:'/creators', component: Creators, auth:false },
  { path:'/store', component: Collections, auth:false },
  { path:'/resources', component: Resources, auth:false },
  
  { path:'/in/home', component: HomeUser, auth:false },
  { path:'/in/store', component: Store, auth:false },
  { path:'/in/vault', component: Vault, auth:false },

  { path:'/in/collections/create', component: CollectionsCreate, auth:false },
  { path:'/in/collections/list', component: CollectionsList, auth:false },
  { path:'/in/cx/v/:id', component: CollectionsView, auth:false },

  { path:'/in/media/create', component: MediaCreate, auth:false },
  { path:'/in/mx/v/:id', component: MediaView, auth:false },
  { path:'/in/mx/e/:id', component: MediaEdit, auth:false },

  { path:'/in/tokens/create', component: TokensCreate, auth:false },
  { path:'/in/tokens/mint', component: TokensMint, auth:false },
  { path:'/in/tokens/v/:id', component: TokensView, auth:false },

  { path:'/in/network', component: Network, auth:false },
  { path:'/in/network/invite', component: NetworkInvite, auth:false },

  { path:'/in/transfers', component: TransfersList, auth:false },
  { path:'/in/transfers/debit', component: TransfersDebit, auth:false },
  { path:'/in/account/credit', component: AccountCredit, auth:false },

  { path:'/in/accounts', component: AccountsList, auth:false },

  { path:'/in/settings', component: Settings, auth:false },

  { path:'/auth', component: AuthMailFirebase, auth:false },
  { path:'/auth/check', component: AuthMailCheckFirebase, auth:false },
  { path:'/auth/next', component: AuthNext, auth:false },
  { path:'/auth/x', component: AuthSessionX, auth:true },

  { path:'/auth/service', component: AuthService, auth:false },

  // { path:'/auth/w', component: AuthWeb3, auth:false },

  { path:'/onboard/user', component: OnboardUser, auth:true },
  // { path:'/onboard/daos', component: OnboardBusiness, auth:true },
  // { path:'/onboard/web3/:id', component: OnboardWeb3, auth:true },

]

const PrivateRoute = (props) => {
  const location = useLocation();
  
  const { user } = useAuth();
  return user 
  ? ( <Route { ...props } /> ) 
  : ( <Redirect to={{ pathname: "/", state: { from: location } }} /> )
};

export default function Routes() {

  return (
    <Switch>
      {routes.map ((item,i)=>(item.auth
      ? <PrivateRoute
          key={i}
          path={item.path}
          component={item.component}
          exact
        />
      : <Route
          key={i}
          path={item.path}
          component={item.component}
          exact
        />
      ))}
    </Switch>
  );
}